import { Div } from '@tblabs/truffle';
import { SensorsBox } from './SensorsBox';
import { VibrasBox } from '../Components/VibraBox';
import { AppSettings } from '../../Services/AppSettings';
import { Translations } from '../../Translations/Translations';
import { IoLogic } from '../IoLogic';


export class IoBox extends Div
{
    private readonly sensorsBox: SensorsBox;
    private readonly vibraBox: VibrasBox;

    constructor(private _ioLogic: IoLogic, private _lang: Translations, private _settings: AppSettings)
    {
        super();
        
        this.sensorsBox = new SensorsBox(this._ioLogic, this._lang, this._settings)
            .Visible(this._ioLogic.ShowSensorsBox, "block");
        this.vibraBox = new VibrasBox(this._ioLogic, this._lang)
            .Visible(this._ioLogic.ShowVibraBox, "block");

        this.Append(
            this.sensorsBox,
            this.vibraBox,
        );
    }
}
